export class PerifericoMovilModel {
  producto: string;
  numeroSerie: number;

  constructor() { }
}
